import callNativeMobileApp from './callNativeMobileApp';

export function callNativeAppRemoveLastRoute(mobileAppTabIdentifier) {
  console.log('enter to callNativeAppRemoveLastRoute');
  callNativeMobileApp({
    action: 'remove_last_route',
    payload: {
      mobileAppTabIdentifier,
    },
  });
}
